var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCameraBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00018 8C5.00018 6.34315 6.34333 5 8.00018 5C9.65704 5 11.0002 6.34315 11.0002 8C11.0002 9.65685 9.65704 11 8.00018 11C6.34333 11 5.00018 9.65685 5.00018 8ZM4.78386 0.826432C5.03849 0.319766 5.55707 0 6.12412 0H9.88832C10.4565 0 10.976 0.321059 11.23 0.829302L11.8149 1.9994H13.5049C14.8856 1.9994 16.0049 3.11869 16.0049 4.4994V12.5C16.0049 13.8807 14.8856 15 13.5049 15H2.50488C1.12417 15 0.00488281 13.8807 0.00488281 12.5V4.4994C0.00488281 3.11868 1.12417 1.9994 2.50488 1.9994H4.19437L4.78386 0.826432ZM8.00018 4C5.79104 4 4.00018 5.79086 4.00018 8C4.00018 10.2091 5.79104 12 8.00018 12C10.2093 12 12.0002 10.2091 12.0002 8C12.0002 5.79086 10.2093 4 8.00018 4Z",
    fill: "#34495E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraBlack);
export default __webpack_public_path__ + "static/media/camera-black.062182ab8324297ff9d325f2607f8528.svg";
export { ForwardRef as ReactComponent };